/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Why_Testimonial_2_RoleInputs */

const es_home_why_testimonial_2_role = /** @type {(inputs: Home_Why_Testimonial_2_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal Corporativo`)
};

const en_home_why_testimonial_2_role = /** @type {(inputs: Home_Why_Testimonial_2_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corporate Legal`)
};

/**
* | output |
* | --- |
* | "Corporate Legal" |
*
* @param {Home_Why_Testimonial_2_RoleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_why_testimonial_2_role = /** @type {((inputs?: Home_Why_Testimonial_2_RoleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Why_Testimonial_2_RoleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_why_testimonial_2_role(inputs)
	return en_home_why_testimonial_2_role(inputs)
});
export { home_why_testimonial_2_role as "home.why.testimonial_2_role" }